// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e7e335a7","239":"4e13017a","455":"bc8d0d6e"}[chunkId] + ".chunk.js";
};